import { Text } from '@mantine/core';

import { formatMenuDate } from '../helpers';

type LastUpdatedTextProps = {
  date: string | null | undefined;
};

export const LastUpdatedText: React.FC<LastUpdatedTextProps> = ({ date }) => {
  if (!date) return null;

  return (
    <Text size="xs" c="dimmed">
      Updated{' '}
      <Text span c="black">
        {formatMenuDate(date)}
      </Text>
    </Text>
  );
};
